import React, { useEffect, useState } from "react";
import useApi from "../../CustomHooks/useApi";

const MerchantBankApprove = () => {
    const [pendingList, setPendingList] = useState([]);
    const [loading, setLoading] = useState(false);

    const [selectedItem, setSelectedItem] = useState(null);
    const [rejectRemark, setRejectRemark] = useState("");

    const [verifyLoading, setVerifyLoading] = useState(false);
    const [verifiedData, setVerifiedData] = useState(null);

    const [isRestricted, setIsRestricted] = useState(false);
    
    useEffect(() => {
        try {
            const storedUser = JSON.parse(localStorage.getItem("user"));
            if (storedUser?.mobile_number === "9555070003" && storedUser?.userId === "COMPLIANCE810104215355") {
                setIsRestricted(true);
            }
        } catch (error) {
            console.error("Error reading user from localStorage", error);
        }
    }, []);

    // =========================
    // GET Pending List
    // =========================
    const { callApi: compilancepending } = useApi(
        `/cheque/compliance/pending`,
        "GET"
    );

    // =========================
    // Approve API
    // =========================
    const { callApi: approveCompliance } = useApi(
        `/cheque/compliance/approve`,
        "POST"
    );

    // =========================
    // Reject API
    // =========================
    const { callApi: rejectCompliance } = useApi(
        `/cheque/compliance/reject`,
        "POST"
    );

    // =========================
    // Verify Bank API
    // =========================
    const { callApi: verifyBankApi } = useApi(
        `/staff/onboard/verify/bene/details`,
        "POST"
    );

    // =========================
    // Fetch Pending List
    // =========================
    const fetchPendingData = async () => {
        setLoading(true);

        try {
            const response = await compilancepending();

            console.log("Pending Response:", response);

            if (Array.isArray(response)) {
                setPendingList(response);
            } else if (response?.data) {
                setPendingList(response.data);
            } else {
                setPendingList([]);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    // useEffect(() => {
    //     fetchPendingData();
    // }, []);
    useEffect(() => {
        if (!isRestricted) {
            fetchPendingData();
        }
    }, [isRestricted]);

    // =========================
    // Verify Bank
    // =========================
    const handleVerifyBank = async (item) => {
        setVerifyLoading(true);

        try {
            const payload = {
                beneficiaryAccount: item?.accountNumber,
                beneficiaryIFSC: item?.ifscCode,
                beneficiaryName: item?.fullName,
                beneficiaryMobile: item?.mobile,
                nameMatchScore: "80",
                nameFuzzy: true,
                email: "merchant@example.com",
                bankName: item?.bankName,
            };

            console.log("Verify Payload:", payload);

            const response = await verifyBankApi(payload);

            console.log("Verify Response:", response);

            setVerifiedData(response?.data || response);
        } catch (error) {
            console.log(error);
        } finally {
            setVerifyLoading(false);
        }
    };

    // =========================
    // Approve
    // =========================
    const handleApprove = async (beneId) => {
        try {
            const response = await approveCompliance(
                {},
                `?beneId=${beneId}`
            );

            console.log("Approve Response:", response);

            alert("Approved Successfully");

            setSelectedItem(null);
            setVerifiedData(null);

            fetchPendingData();
        } catch (error) {
            console.log(error);
        }
    };

    // =========================
    // Reject
    // =========================
    const handleReject = async (beneId) => {
        if (!rejectRemark) {
            alert("Please Enter Reject Remark");
            return;
        }

        try {
            const response = await rejectCompliance(
                {},
                `?beneId=${beneId}&remarks=${encodeURIComponent(
                    rejectRemark
                )}`
            );

            console.log("Reject Response:", response);

            alert("Rejected Successfully");

            setSelectedItem(null);
            setRejectRemark("");
            setVerifiedData(null);

            fetchPendingData();
        } catch (error) {
            console.log(error);
        }
    };

    // =========================
    // Open Popup
    // =========================
    const handleOpenPopup = (item) => {
        setSelectedItem(item);
        setVerifiedData(null);
        setRejectRemark("");
    };

    if (isRestricted) {
        return (
            <div className="flex flex-col items-center justify-center h-[70vh] p-4 text-center">
                <div className="bg-red-50 border border-red-200 rounded-2xl p-8 max-w-md shadow-sm">
                    <h2 className="text-2xl font-bold text-red-600 mb-2">Access Denied</h2>
                    <p className="text-gray-600">
                        You do not have access to this page.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="p-4">
            <h1 className="text-2xl font-bold mb-4">
                Bank Compliance Pending
            </h1>

            <div className="overflow-x-auto bg-white shadow rounded-lg">
                <table className="min-w-full border border-gray-200">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="border p-3">S.No</th>
                            <th className="border p-3">ID</th>
                            <th className="border p-3">Full Name</th>
                            <th className="border p-3">Shop Name</th>
                            <th className="border p-3">PAN Card</th>
                            <th className="border p-3">Aadhaar</th>
                            <th className="border p-3">Account No</th>
                            <th className="border p-3">Cheque</th>
                            <th className="border p-3">Status</th>
                            <th className="border p-3">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {loading ? (
                            <tr>
                                <td
                                    colSpan="10"
                                    className="text-center p-4"
                                >
                                    Loading...
                                </td>
                            </tr>
                        ) : pendingList?.length > 0 ? (
                            pendingList.map((item, index) => (
                                <tr key={index} className="text-center">
                                    <td className="border p-3">
                                        {index + 1}
                                    </td>

                                    <td className="border p-3">
                                        {item?.id}
                                    </td>

                                    <td className="border p-3">
                                        {item?.fullName}
                                    </td>

                                    <td className="border p-3">
                                        {item?.shopName}
                                    </td>

                                    <td className="border p-3">
                                        {item?.panCard}
                                    </td>

                                    <td className="border p-3">
                                        {item?.aadhaarNumber}
                                    </td>

                                    <td className="border p-3">
                                        {item?.accountNumber}
                                    </td>

                                    <td className="border p-3">
                                        {item?.cancelledChequeUrl ? (
                                            <a
                                                href={item?.cancelledChequeUrl}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="text-blue-600 underline"
                                            >
                                                View
                                            </a>
                                        ) : (
                                            "N.A"
                                        )}
                                    </td>

                                    <td className="border p-3">
                                        <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-sm">
                                            {item?.status}
                                        </span>
                                    </td>

                                    <td className="border p-3">
                                        <button
                                            onClick={() =>
                                                handleOpenPopup(item)
                                            }
                                            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1 rounded"
                                        >
                                            View
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan="10"
                                    className="text-center p-4"
                                >
                                    No Pending Data Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* =========================
          POPUP MODAL
      ========================= */}

            {selectedItem && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-3">
                    <div className="bg-white rounded-xl w-full max-w-2xl p-6 max-h-[90vh] overflow-y-auto">

                        <h2 className="text-2xl font-bold mb-5">
                            Merchant Details
                        </h2>

                        {/* Merchant Details */}

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                            <div>
                                <p className="font-semibold">ID</p>
                                <p>{selectedItem?.id}</p>
                            </div>

                            <div>
                                <p className="font-semibold">Full Name</p>
                                <p>{selectedItem?.fullName}</p>
                            </div>

                            <div>
                                <p className="font-semibold">Shop Name</p>
                                <p>{selectedItem?.shopName}</p>
                            </div>

                            <div>
                                <p className="font-semibold">PAN Card</p>
                                <p>{selectedItem?.panCard}</p>
                            </div>

                            <div>
                                <p className="font-semibold">Aadhaar Number</p>
                                <p>{selectedItem?.aadhaarNumber}</p>
                            </div>

                            <div>
                                <p className="font-semibold">Mobile</p>
                                <p>{selectedItem?.mobile}</p>
                            </div>

                            <div>
                                <p className="font-semibold">Bank Name</p>
                                <p>{selectedItem?.bankName}</p>
                            </div>

                            <div>
                                <p className="font-semibold">
                                    Account Number
                                </p>
                                <p>{selectedItem?.accountNumber}</p>
                            </div>

                            <div>
                                <p className="font-semibold">IFSC Code</p>
                                <p>{selectedItem?.ifscCode}</p>
                            </div>

                            <div>
                                <p className="font-semibold">Status</p>
                                <p>{selectedItem?.status}</p>
                            </div>

                        </div>

                        {/* Cancelled Cheque */}

                        <div className="mt-5">
                            <p className="font-semibold mb-2">
                                Cancelled Cheque
                            </p>

                            {selectedItem?.cancelledChequeUrl ? (
                                <a
                                    href={selectedItem?.cancelledChequeUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    View Cheque
                                </a>
                            ) : (
                                <p>N.A</p>
                            )}
                        </div>

                        {/* Verify Button */}

                        <div className="mt-6">
                            <button
                                onClick={() =>
                                    handleVerifyBank(selectedItem)
                                }
                                className="bg-indigo-600 hover:bg-indigo-700 text-white px-5 py-2 rounded-lg"
                            >
                                {verifyLoading
                                    ? "Verifying..."
                                    : "Verify Bank"}
                            </button>
                            <p className="text-sm text-red-600 mt-2 font-medium">
                                ₹3 will be deducted for bank verification.
                                Verify only if needed.
                                <br />
                                बैंक वेरिफिकेशन के लिए ₹3 कटेंगे।
                                केवल जरूरत होने पर ही Verify करें।
                            </p>
                        </div>

                        {/* Verified Data */}

                        {verifiedData && (
                            <div className="mt-6 bg-green-50 border border-green-300 rounded-xl p-5">

                                <h3 className="text-xl font-bold text-green-700 mb-4">
                                    Verified Bank Details
                                </h3>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                                    <div>
                                        <p className="font-semibold">
                                            Account Holder
                                        </p>

                                        <p>
                                            {verifiedData?.beneficiaryName ||
                                                verifiedData?.accountHolderName ||
                                                selectedItem?.fullName}
                                        </p>
                                    </div>

                                    <div>
                                        <p className="font-semibold">
                                            Account Number
                                        </p>

                                        <p>
                                            {verifiedData?.beneficiaryAccount ||
                                                selectedItem?.accountNumber}
                                        </p>
                                    </div>

                                    <div>
                                        <p className="font-semibold">
                                            IFSC Code
                                        </p>

                                        <p>
                                            {verifiedData?.beneficiaryIFSC ||
                                                selectedItem?.ifscCode}
                                        </p>
                                    </div>

                                    <div>
                                        <p className="font-semibold">
                                            Bank Name
                                        </p>

                                        <p>
                                            {verifiedData?.bankName ||
                                                selectedItem?.bankName}
                                        </p>
                                    </div>

                                    <div>
                                        <p className="font-semibold">
                                            Match Score
                                        </p>

                                        <p>
                                            {verifiedData?.nameMatchScore ||
                                                "80"}
                                        </p>
                                    </div>

                                    <div>
                                        <p className="font-semibold">
                                            Verification Status
                                        </p>

                                        <p className="text-green-700 font-semibold">
                                            {verifiedData?.status ||
                                                "Verified"}
                                        </p>
                                    </div>

                                </div>
                            </div>
                        )}

                        {/* Reject Remark */}

                        <div className="mt-5">
                            <textarea
                                placeholder="Enter Reject Remark"
                                value={rejectRemark}
                                onChange={(e) =>
                                    setRejectRemark(e.target.value)
                                }
                                className="w-full border rounded-lg p-3"
                                rows={4}
                            />
                        </div>

                        {/* Buttons */}

                        <div className="flex flex-wrap justify-end gap-3 mt-6">

                            <button
                                onClick={() => {
                                    setSelectedItem(null);
                                    setVerifiedData(null);
                                }}
                                className="bg-gray-500 hover:bg-gray-600 text-white px-5 py-2 rounded-lg"
                            >
                                Close
                            </button>

                            <button
                                onClick={() =>
                                    handleApprove(selectedItem?.id)
                                }
                                className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-lg"
                            >
                                Approve
                            </button>

                            <button
                                onClick={() =>
                                    handleReject(selectedItem?.id)
                                }
                                className="bg-red-600 hover:bg-red-700 text-white px-5 py-2 rounded-lg"
                            >
                                Reject
                            </button>

                        </div>

                    </div>
                </div>
            )}
        </div>
    );
};

export default MerchantBankApprove;